import { render } from "./Notificacao.vue?vue&type=template&id=4e1d0700"
import script from "./Notificacao.vue?vue&type=script&lang=ts"
export * from "./Notificacao.vue?vue&type=script&lang=ts"
script.render = render

export default script